import {Component, Input, OnInit} from '@angular/core';
import {SocialService} from '../../../services/social.service';
import { Router, ActivatedRoute } from '@angular/router';
import { HttpParams } from '@angular/common/http';

@Component({
  selector: 'app-social',
  templateUrl: './social.component.html',
  styleUrls: [
    './social.component.scss',
    './social.component.desktop.scss'
  ]
})
export class SocialComponent implements OnInit {

  @Input() provider: string;
  label: string;
  providerSetting: string;
  providerURL: string;

  constructor(private socialService: SocialService, private router: Router, private activatedRoute: ActivatedRoute) {}

  ngOnInit() {
    this.label = this.provider.charAt(0).toUpperCase() + this.provider.slice(1);
    this.providerSetting = this.socialService.getProviderSetting(this.provider);
    this.providerURL = this.socialService.getProviderURL(this.provider);
    let params = new HttpParams();

    // removing possible outlet in the route
    const returnToUrl = this.router.routerState.snapshot.url.replace(/\(([^)]+)\)/, '');
    params = params.append('returnToUrl', encodeURIComponent(returnToUrl));

    // Store the url we came from in order to send the user back after a successful login.
    this.providerURL += '?returnToUrl=' + encodeURIComponent(returnToUrl);
  }
}
